import { Select } from "antd";
import React from "react";

export default function TapeCount({ tapeRolls, selectedTapePrice, setSelectedTapePrice }) {
  const handleRollCountSelect = (value, option) => {
    console.log(option);
    setSelectedTapePrice(option);
  };

  //changes the label
  const formattedTapeRolls = tapeRolls.map((item) => ({
    ...item,
    label: `Rolls : ${item.rolls} (boxes: ${item.boxCount}) | Price : ${item.price}`,
  }));

  return (
    <>
      <Select
        showSearch
        fieldNames={{ label: "label", value: "rolls" }}
        options={formattedTapeRolls}
        value={selectedTapePrice.label}
        onChange={(value, option) => handleRollCountSelect(value, option)}
        placeholder="Select label count"
        optionFilterProp="children"
        style={{ width: "100%" }}
        filterSort={(a, b) => a.value - b.value}
      />
    </>
  );
}
